/**
 * External dependencies
 */
import React from "react";
import { withPrefix } from "gatsby";
import { Nav, Navbar, Form, Container } from "react-bootstrap";

/**
 * Internal dependencies
 */
import { Link, SearchInput } from "../components";
import { noOfItemsInCart, noOfItemsInList, slugify } from "../utilities";

function NavigationItem(props) {
  const { children, category } = props;
  return (
    <li role="presentation" className="">
      <Link to={`/category/${slugify(category)}`}>{children}</Link>
    </li>
  );
}

export default class extends React.Component {
  state = {
    cartCount: "Cart (0 Items)",
    wishlistCount: "Wishlist (0 Items)"
  };

  componentDidMount() {
    this.setState({
      cartCount: noOfItemsInCart(),
      wishlistCount: noOfItemsInList()
    });
  }

  render() {
    const logoPath = withPrefix(`/images/inkcredible-retail-logo.png`);
    return (
      <Navbar bg="light" expand="lg" className="navbar-default">
        <Container>
          <Navbar.Brand>
            <Link to="/">
              <img src={logoPath} alt="" className="logo-img" />
            </Link>
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <ul className={"nav navbar-nav"}>
                <NavigationItem category={"mens"}>Men's</NavigationItem>
                <NavigationItem category={"womens"}>Women's</NavigationItem>
              </ul>
            </Nav>
            <Nav className="inkredible-nav-form">
              <Form inline>
                <SearchInput />
                <Link to="/cart" className={"cart-btn btn btn-default"}>
                  <span>{this.state.cartCount}</span>
                </Link>
              </Form>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}
